import { useEffect, useRef, useState } from "react";

function isFunction<T>(value: T | (() => T)): value is (() => T) {
    return typeof value === 'function';
}

export function useReffedState<T>(initialValue: T | (() => T)): [T, React.Dispatch<React.SetStateAction<T>>, React.MutableRefObject<T>] {
    const [value, setValue] = useState<T>(initialValue);
    const refVal = isFunction(initialValue) ? initialValue() : initialValue;
    const ref = useRef<T>(refVal);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return [value, setValue, ref];
}